"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Plus } from "lucide-react";
const faqs = [{
  id: "mobile",
  questionBefore: "Do you come to my ",
  questionItalic: "home",
  questionAfter: " or office?",
  answer: "\n"
}, {
  id: "duration",
  questionBefore: "How long does a service ",
  questionItalic: "typically",
  questionAfter: " take?",
  answer: "Service times vary by package and vehicle condition, typically ranging from 1 to 6 hours."
}, {
  id: "area",
  questionBefore: "What is your service ",
  questionItalic: "area",
  questionAfter: " coverage?",
  answer: "We serve Miami-Dade and surrounding areas.\nTravel fees may apply depending on the location."
}, {
  id: "booking",
  questionBefore: "How do I secure a ",
  questionItalic: "booking",
  questionAfter: "?",
  answer: "Book directly through WhatsApp or the contact form.\nWe’ll confirm your appointment and service details."
}];
export default function Faq() {
  return;
}